import { Icon } from "@iconify/react";
import Card from "../common/Card";
import Button from "../common/Button";
import LoadingSpinner from "../common/LoadingSpinner";
import {
  getPlatformIcon,
  getPlatformColor,
  getConnectionStatusLabel,
  getConnectionStatusColor,
} from "../../utils/websiteHelpers";

const WebsiteConnectionCard = ({
  website,
  onEdit,
  onTest,
  onConnect,
  onDelete,
  isTesting = false,
}) => {
  const websiteId = website._id || website.id;
  const isShopify = website.platform === "shopify";
  const isConnected = website.connectionStatus === "connected";
  const showConnectButton = !isShopify || !isConnected;

  return (
    <Card className="relative">
      <div className="flex items-start justify-between mb-4">
        <div className="flex items-center gap-3">
          <div
            className={`w-12 h-12 rounded-lg ${getPlatformColor(website.platform)} flex items-center justify-center text-white`}
          >
            <Icon
              icon={getPlatformIcon(website.platform)}
              className="text-2xl"
            />
          </div>
          <div className="min-w-0">
            <h3 className="font-semibold text-text-dark truncate">
              {website.siteName || "Unnamed Site"}
            </h3>
            <p className="text-sm text-text-secondary capitalize">
              {website.platform}
            </p>
          </div>
        </div>
        <div className="flex flex-col items-end gap-1">
          <span
            className={`px-2 py-1 rounded-full text-xs font-semibold ${website.isActive
                ? "bg-success/20 text-success"
                : "bg-danger/20 text-danger"
              }`}
          >
            {website.isActive ? "Active" : "Inactive"}
          </span>
          {isShopify && website.connectionStatus !== "disconnected" && (
            <span
              className={`px-2 py-1 rounded-full text-xs font-semibold ${getConnectionStatusColor(website.connectionStatus)}`}
            >
              {getConnectionStatusLabel(website.connectionStatus)}
            </span>
          )}
        </div>
      </div>

      <div className="space-y-2 mb-4">
        <div className="flex items-center gap-2 text-sm text-text-secondary">
          <Icon icon="mdi:link" className="text-lg flex-shrink-0" />
          <a
            href={website.siteUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="text-primary hover:underline truncate"
          >
            {website.siteUrl}
          </a>
        </div>
        {website.apiKey && (
          <div className="flex items-center gap-2 text-sm text-text-secondary">
            <Icon icon="mdi:key" className="text-lg flex-shrink-0" />
            <span className="font-mono text-xs truncate">
              {website.apiKey?.substring(0, 20)}...
            </span>
          </div>
        )}
      </div>

      <div className={`grid ${showConnectButton ? "grid-cols-3" : "grid-cols-2"} gap-2 pt-4 border-t border-border-light`}>
        <Button
          variant="secondary"
          size="sm"
          icon="mdi:pencil"
          onClick={() => onEdit(website)}
          className="w-full px-2"
        >
          Edit
        </Button>
        {showConnectButton && (
          <Button
            variant="secondary"
            size="sm"
            // icon="mdi:connection"
            onClick={() => (isShopify ? onConnect(website.siteUrl) : onTest(websiteId))}
            disabled={!isShopify && isTesting}
            className="w-full px-2"
          >
            {!isShopify && isTesting ? <LoadingSpinner size="sm" /> : isShopify ? "Connect" : "Test"}
          </Button>
        )}
        <Button
          variant="secondary"
          size="sm"
          icon="mdi:delete"
          onClick={() => onDelete(websiteId)}
          className="w-full text-danger hover:bg-danger border border-danger px-2"
        >
          Delete
        </Button>
      </div>
    </Card>
  );
};

export default WebsiteConnectionCard;
